<form fxLayout="column" fxLayoutGap="20px" [formGroup]="datiFattForm" #form>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">
        Spedizione fattura
      </h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" class="modalita-spedizione">

    <div fxLayout="row" fxLayoutGap="10px" *ngIf="dataService.prodotto?.tipo_utenza != 'DOM'">
      <ng-container *ngIf="datiAnaForm.get('tipoCliente')?.value == '0'">
        <mat-form-field>
          <input [required]="setRequired(datiFattForm.get('sdi'))" matInput placeholder="Codice SDI" formControlName="sdi" [maxLength]="7">
          <mat-error *ngIf="datiFattForm.get('sdi')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </ng-container>
      <mat-form-field>
        <input [required]="setRequired(datiFattForm.get('pec'))" matInput placeholder="Pec" formControlName="pec" oninput="this.value = this.value.toLowerCase()">
        <mat-error *ngIf="datiFattForm.get('pec')?.hasError('required')">
          <strong>Campo obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="modalitaSpedizione">
      <mat-radio-button value="0" fxLayoutAlign="start start">
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
          E-mail
        </div>
      </mat-radio-button>
      <ng-container *ngIf="dataService.user != 2">
        <mat-radio-button value="1" fxLayoutAlign="start start">
          Cartacea
        </mat-radio-button>
      </ng-container>
    </mat-radio-group>
  </div>
  <div class="spedizione-options" fxLayout="column" fxLayoutGap="10px">

    <mat-card *ngIf="datiFattForm.get('modalitaSpedizione')!.value == '0'" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start center">
      <ng-container formArrayName="mails">
        <ng-container *ngFor="let mail of mails.controls; index as i">
          <mat-form-field>
            <input [required]="setRequired(mail)" [formControlName]="i" matInput placeholder="E-mail" oninput="this.value = this.value.toLowerCase()">
            <mat-error *ngIf="mail.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
            <button *ngIf="i != 0" matSuffix mat-icon-button aria-label="Elimina" (click)="removeMail(i)">
              <mat-icon color="warn">remove_circle</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </ng-container>

      <button mat-icon-button (click)="addMail()" *ngIf="mails.value.length < 3">
        <mat-icon color="primary">add_circle</mat-icon>
      </button>
    </mat-card>
    <mat-card *ngIf="datiFattForm.get('modalitaSpedizione')!.value == '1'" class="indirizzo-spedizione">
      <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="tipoIndirizzoCart">
        <mat-radio-button value="0">Indirizzo uguale a quello
          {{dataService.datiAnagrafici?.get('tipoCliente')?.value == '0' ? 'legale': 'di residenza'}}
        </mat-radio-button>
        <mat-radio-button value="1">Indirizzo uguale a quello di fornitura
        </mat-radio-button>
        <mat-radio-button value="2" id="nuovo-indirizzo">
          <div fxLayout="row" fxLayoutGap="10px">
            Nuovo indirizzo
          </div>
          <div fxLayout="row" *ngIf="datiFattForm.get('tipoIndirizzoCart')!.value == '2'" class="indirizzo-form">
            <app-indirizzo [indirizzoForm]="indirizzoForm" options="presso"></app-indirizzo>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-card>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title">
          Fatturazione
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div>
      <mat-radio-group formControlName="accorpaFatture" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-button value="0" [disabled]="fatturaUnica">Invio unica fattura per tutti i POD o PDR</mat-radio-button>
        <mat-radio-button value="1">Invio fattura singola per ogni POD o PDR</mat-radio-button>
      </mat-radio-group>
    </div>

  </div>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">Pagamento</h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <!-- ============================================================ -->
  <!-- STEP 1 — POD MASTER                                          -->
  <!-- Solo DOM: l'utente sceglie. BUS: sempre master, non mostrato -->
  <!-- ============================================================ -->
  <ng-container *ngIf="dataService.prodotto?.tipo_utenza === 'DOM'" [formGroup]="podMaster">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div><h3 class="divider-title">Tipo POD</h3></div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <mat-checkbox formControlName="isPodMaster" color="primary">POD Master</mat-checkbox>
      <mat-hint style="font-size: 12px; color: rgba(255, 255, 255, 0.6);">
        (Deseleziona se questo POD non è il punto di riferimento)
      </mat-hint>
    </div>

    <!-- POD di Riferimento: visibile solo se NOT isPodMaster -->
    <div *ngIf="!podMaster.get('isPodMaster')?.value" fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field fxFlex="500px">
        <mat-label>POD Master di Riferimento</mat-label>
        <input
          matInput
          [formControl]="podMasterSearchControl"
          [matAutocomplete]="autoPodMaster"
          placeholder="Cerca per cliente, codice adesione o POD..."
          [required]="setRequired(podMaster.get('podMasterRiferimento'))">
        <mat-autocomplete
          #autoPodMaster="matAutocomplete"
          [displayWith]="displayPodMaster.bind(this)"
          (optionSelected)="podMaster.get('podMasterRiferimento')?.setValue($event.option.value)">
          <mat-option
            *ngFor="let opt of filteredPodMasterOptions | async"
            [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-autocomplete>
        <mat-hint *ngIf="podMasterOptions.length === 0"
          style="font-size: 12px; color: rgba(255,255,255,0.5);">
          Nessun POD Master disponibile
        </mat-hint>
        <mat-error *ngIf="podMaster.get('podMasterRiferimento')?.hasError('required')">
          <strong>Campo obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>

  </ng-container>

  <!-- ============================================================ -->
  <!-- STEP 2 — GESTIONE PACCHETTO CLIENTE                          -->
  <!-- Visibile se: isPodMaster=true, prodotto EE, aumix=SI         -->
  <!-- ============================================================ -->
  <ng-container *ngIf="mostraGestionePacchetto" [formGroup]="gestionePacchetto">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div><h3 class="divider-title">Pacchetto Cliente</h3></div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">

      <!-- Selettore pacchetto -->
      <mat-form-field fxFlex="300px">
        <mat-label>Tipo pacchetto</mat-label>
        <mat-select formControlName="pacchettoCliente">
          <mat-option *ngFor="let p of pacchettiCliente" [value]="p.id">
            {{p.codice}} - {{p.kwh_annui | number}} kWh
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Acconto benvenuto: visibile solo se pacchetto selezionato -->
      <mat-form-field fxFlex="300px" *ngIf="gestionePacchetto.get('pacchettoCliente')?.value">
        <mat-label>Acconto benvenuto (kWh)</mat-label>
        <input matInput type="number" formControlName="accontoBenvenuto"
          [required]="setRequired(gestionePacchetto.get('accontoBenvenuto'))">
        <mat-hint style="font-size: 12px; color: rgba(255, 255, 255, 0.6);">Default: (1/3 del volume annuo)</mat-hint>
        <mat-error *ngIf="gestionePacchetto.get('accontoBenvenuto')?.hasError('pattern')">
          <strong>Inserire un valore numerico intero</strong>
        </mat-error>
        <mat-error *ngIf="gestionePacchetto.get('accontoBenvenuto')?.hasError('required')">
          <strong>Campo obbligatorio</strong>
        </mat-error>
      </mat-form-field>

      <!-- Suddivisione per POD: visibile solo se pacchetto selezionato -->
      <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100"
        *ngIf="gestionePacchetto.get('pacchettoCliente')?.value">
        <mat-checkbox formControlName="ripartitoPerPod" color="primary">
          Suddivisione per POD
        </mat-checkbox>
      </div>

    </div>
  </ng-container>

  <!-- ============================================================ -->
  <!-- STEP 3 — GESTIONE ACCONTO ALLA FIRMA                         -->
  <!-- Visibile se: isPodMaster=true e pacchetto selezionato        -->
  <!-- ============================================================ -->
  <ng-container *ngIf="mostraGestioneAcconto" [formGroup]="gestioneAcconto">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div><h3 class="divider-title">Acconto alla Firma</h3></div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="column" fxLayoutGap="20px" class="gestione-acconto-form">

      <!-- RIGA 1: Prezzo pacchetto, Sconto, Prezzo finale -->
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">

        <!-- Prezzo pacchetto: read-only, non è un FormControl -->
        <mat-form-field fxFlex="300px">
          <mat-label>Prezzo pacchetto (€)</mat-label>
          <input matInput type="number" [value]="prezzoPacchetto" readonly style="cursor: not-allowed;">
        </mat-form-field>

        <!-- Sconto pacchetto -->
        <mat-form-field fxFlex="300px">
          <mat-label>Sconto (%)</mat-label>
          <input matInput type="number" step="1" min="0" max="100"
            formControlName="scontoPacchetto">
          <mat-error *ngIf="gestioneAcconto.get('scontoPacchetto')?.hasError('min') ||
                            gestioneAcconto.get('scontoPacchetto')?.hasError('max')">
            Il valore deve essere compreso tra 0 e 100
          </mat-error>
        </mat-form-field>

        <!-- Prezzo finale scontato — visibile solo se sconto > 0 -->
        <mat-form-field fxFlex="300px"
            *ngIf="gestioneAcconto.get('scontoPacchetto')?.value > 0">
          <mat-label>Prezzo finale (€)</mat-label>
          <input matInput type="number" [value]="prezzoPacchettoScontato" readonly style="cursor: not-allowed;">
          <mat-hint style="font-size: 12px; color: rgba(255,255,255,0.5);">
            Prezzo dopo applicazione sconto
          </mat-hint>
        </mat-form-field>

      </div>

      <!-- RIGA 2: Acconto alla firma, Saldo residuo -->
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">

        <!-- Acconto alla firma: inserito liberamente dall'utente -->
        <mat-form-field fxFlex="300px">
          <mat-label>Acconto alla firma (€) - IVA esclusa</mat-label>
          <input matInput type="number" step="0.01"
            formControlName="importoAcconto"
            [required]="setRequired(gestioneAcconto.get('importoAcconto'))">
          <mat-error *ngIf="gestioneAcconto.get('importoAcconto')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="gestioneAcconto.get('importoAcconto')?.hasError('min')">
            Il valore deve essere maggiore o uguale a 0
          </mat-error>
        </mat-form-field>

        <!-- Saldo residuo: visibile solo se importoAcconto > 0 -->
        <mat-form-field fxFlex="300px" *ngIf="saldoResiduo !== null">
          <mat-label>Saldo residuo (€)</mat-label>
          <input matInput type="number" [value]="saldoResiduo" readonly style="cursor: not-allowed;">
          <mat-hint style="font-size: 12px; color: rgba(255,255,255,0.5);">Prezzo pacchetto − acconto alla firma</mat-hint>
        </mat-form-field>

      </div>

      <!-- Rateizzazione: visibile solo se saldo residuo è valorizzato -->
      <ng-container *ngIf="saldoResiduo !== null">

        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-checkbox formControlName="rateizzato" color="primary">Rateizza il saldo residuo</mat-checkbox>
        </div>

        <div *ngIf="gestioneAcconto.get('rateizzato')?.value" fxLayout="column" fxLayoutGap="15px" class="rateizzato-fields">

          <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px">

            <mat-form-field fxFlex="200px">
              <mat-label>Numero di rate</mat-label>
              <input matInput type="number" formControlName="numeroRate"
                [required]="setRequired(gestioneAcconto.get('numeroRate'))">
              <mat-error *ngIf="gestioneAcconto.get('numeroRate')?.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="gestioneAcconto.get('numeroRate')?.hasError('min')">
                Il numero deve essere almeno 1
              </mat-error>
              <mat-error *ngIf="gestioneAcconto.get('numeroRate')?.hasError('pattern')">
                Inserire solo numeri interi
              </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="200px">
              <mat-label>Euro a rata (€)</mat-label>
              <input matInput type="number" step="0.01" formControlName="importoPerRata"
                [required]="setRequired(gestioneAcconto.get('importoPerRata'))">
              <mat-error *ngIf="gestioneAcconto.get('importoPerRata')?.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="250px">
              <mat-label>A partire da bolletta n°</mat-label>
              <input matInput type="number" formControlName="decorrenzaDaBolletta"
                [required]="setRequired(gestioneAcconto.get('decorrenzaDaBolletta'))">
              <mat-error *ngIf="gestioneAcconto.get('decorrenzaDaBolletta')?.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="gestioneAcconto.get('decorrenzaDaBolletta')?.hasError('min')">
                Il numero deve essere almeno 1
              </mat-error>
              <mat-error *ngIf="gestioneAcconto.get('decorrenzaDaBolletta')?.hasError('max')">
                Il numero massimo è 12
              </mat-error>
              <mat-error *ngIf="gestioneAcconto.get('decorrenzaDaBolletta')?.hasError('pattern')">
                Inserire solo numeri interi
              </mat-error>
            </mat-form-field>

          </div>

          <!-- Errore cross-field: rate * importo ≠ saldo residuo -->
          <div *ngIf="discrepanzaRate !== null" style="color: orange; font-size: 13px;">
            Il totale rate differisce dal saldo residuo di {{ discrepanzaRate | number:'1.2-2' }} € (arrotondamento).
          </div>

        </div>

      </ng-container>

    </div>
  </ng-container>

  <div fxLayout="column" fxLayoutGap="10px">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title">
          Modalità
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="modalita">
      <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="modalitaPagamento" fxFlexFill>
        <mat-radio-button value="0">
          Domiciliazione bancaria
          <mat-card *ngIf="datiFattForm.get('modalitaPagamento')!.value == '0'">
            <!-- <mat-form-field>
                            <input matInput placeholder="Banca" formControlName="banca">
                        </mat-form-field> -->
            <mat-form-field>
              <input matInput [required]="setRequired(datiFattForm.get('iban'))" placeholder="Iban" formControlName="iban" [maxlength]="ibanMaxLength" [minlength]="ibanMinLength">
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('minlength') || datiFattForm.get('iban')?.hasError('maxlength')">
                Lunghezza errata
              </mat-error>
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('pattern')">
                Pattern errato
              </mat-error>
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
            </mat-form-field>
            <div fxLayout="column" fxLayoutGap="10px">
              <h3 class="divider-title"><strong>Titolare conto</strong></h3>
              <form fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="campi-domiciliazione" formGroupName="titolareConto">
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('nome'))" placeholder="Nome" formControlName="nome">
                  <mat-error *ngIf="titolareConto.controls.nome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('cognome'))" placeholder="Cognome" formControlName="cognome">
                  <mat-error *ngIf="titolareConto.controls.cognome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('codiceFiscale'))" placeholder="Codice fiscale" formControlName="codiceFiscale">
                  <mat-error *ngIf="titolareConto.controls.codiceFiscale.hasError('pattern')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                  <mat-error *ngIf="titolareConto.controls.codiceFiscale.hasError('required')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                </mat-form-field>
                <ng-container *ngIf="dataService.prodotto?.tipo_utenza != 'DOM'">
                  <mat-form-field>
                    <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('ragioneSociale'))" placeholder="Ragione sociale" formControlName="ragioneSociale">
                    <mat-error *ngIf="titolareConto.controls.ragioneSociale.hasError('required')">
                      <strong>Campo obbligatorio</strong>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('piva'))" placeholder="Partita IVA" formControlName="piva" [maxLength]="11">
                  </mat-form-field>
                </ng-container>
              </form>
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
              <h3 class="divider-title"><strong>Sottoscrittore mandato</strong></h3>
              <form fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="campi-domiciliazione" formGroupName="sottoscrittore">
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('nome'))" placeholder="Nome" formControlName="nome">
                  <mat-error *ngIf="sottoscrittore.controls.nome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('cognome'))" placeholder="Cognome" formControlName="cognome">
                  <mat-error *ngIf="sottoscrittore.controls.cognome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('codiceFiscale'))" placeholder="Codice fiscale" formControlName="codiceFiscale">
                  <mat-error *ngIf="sottoscrittore.controls.codiceFiscale.hasError('pattern')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                  <mat-error *ngIf="sottoscrittore.controls.codiceFiscale.hasError('required')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                </mat-form-field>
              </form>
            </div>
          </mat-card>
        </mat-radio-button>
        <ng-container *ngIf="(dataService.user == 2 && dataService.prodotto?.tipo_utenza == 'BUS') || dataService.user != 2">
          <mat-radio-button value="1">Bonifico</mat-radio-button>
        </ng-container>
        <!-- <ng-container *ngIf="(dataService.user == 2 && dataService.prodotto?.tipo_utenza == 'DOM') || dataService.user != 2">
          <mat-radio-button value="2">Bollettino postale</mat-radio-button>
        </ng-container> -->
      </mat-radio-group>
    </div>
  </div>
</form>